//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

import SIdentify from '@/components/SIdentify.vue'
import Cookies from '@/plugin/cookies.js'
export default {
  data() {
    return {
      logining: false,
      reminderDialogVisible: false,
      selectVisible: false,
      isVerifyCode: 0,
      loginForm: {
        username: '',
        password: '',
        verifycode: ''
      },
      loginRule: {
        username: [{ required: true, message: '请输入邮箱', trigger: 'blur' }],
        password: [{ required: true, message: '请输入密码', trigger: 'blur' }],
        verifycode: [
          { required: true, message: '请输入验证码', trigger: 'blur' }
        ]
      },
      checked: false,
      agreed: false,
      identifyCodes: '1234567890',
      identifyCode: '',
      userreminder:
        '1）本网站不采集涉及用户隐私的任何信息， 新用户注册用电子邮箱仅用于系统管理员在必要时发送联络信息。\n2）采用移动端设备进行注册的用户，请确认网络连接环境。通过实时扫描（自动上传）包装箱上的条形码进行产品型号和序列号的识别，会因所用移动设备拍照性能的不同而产生一定的互联网流量。\n3）如系统无法准确识别实时扫码信息和条形码照片，可通过手动填写方式进行注册。\n4）如系统已准确识别产品型号与序列号，但提示“没有找到匹配数据”，或在注册中有任何问题，请联系系统管理员。（电话010-65626796，电子邮箱PAVCS_helpdesk@cn.panasonic.com） \n5）设备保修资格确认后，相关信息将在广播电视系统产品保修信息管理系统中管理。同时，相关数据将定期传送到Panasonic系统通讯设备维修管理系统，我们不再提供纸质保修卡。 设备送修时，Panasonic认定维修站可以通过产品型号和产品序列号查看该设备的购买日期、保修有效性、保修特别条款。\n',

      pwdType: 'password',
      eyeType: 'el-input__icon el-icon-view',
      imgSrc: this.$api.validateCode
    }
  },
  components: {
    SIdentify
  },
  created() {
    // 在页面加载时从cookie获取登录信息
    let username = Cookies.getCookie('un')
    let password = Cookies.getCookie('upwds')
    // 如果存在赋值给表单，并且将记住密码勾选
    if (username) {
      this.checked = true
      this.loginForm.username = username
      this.loginForm.password = password
    }
  },

  methods: {
    toregist() {
      this.$router.push({ path: '/regist' })
    },
    handleSubmit(event) {
      this.$refs.loginForm.validate(valid => {
        if (valid) {
          this.logining = true
          let params = {
            UserName: this.loginForm.username.trim(),
            Password: this.loginForm.password.trim(),
            VerifyCode: this.loginForm.verifycode.trim()
          }
          let that = this
          this.$api
            .login(params)
            .then(res => {
              if (res.Status === 1) {
                this.logining = false
                this.isVerifyCode = 0
                sessionStorage.setItem('token', res.Entity)
                sessionStorage.setItem('user', this.loginForm.username.trim())
                if (this.checked) {
                  Cookies.setCookie('un', this.loginForm.username.trim(), 10)
                  Cookies.setCookie('upwds', this.loginForm.password.trim(), 10)
                } else {
                  Cookies.setCookie('un', '')
                  Cookies.setCookie('upwds', '')
                }

                this.selectVisible = true
              } else {
                this.isVerifyCode++
                this.$alert(res.Message, '错误', {
                  confirmButtonText: '确定'
                })
                this.logining = false
                this.refreshCode()
              }
            })
            .catch(function(res) {
              that.$alert('网络出错，无法登录！', '系统错误', {
                confirmButtonText: '确定'
              })
              that.logining = false
              that.refreshCode()
            })
        } else {
          this.$alert('无法登录！', '系统错误', {
            confirmButtonText: '确定'
          })
          this.logining = false
          this.refreshCode()
          return false
        }
      })
    },
    checklogin() {
      this.$refs.loginForm.validate(valid => {
        if (valid) {
          this.reminderDialogVisible = true
        }
      })
    },
    toHome() {
      this.$router.push({ path: '/' })
    },
    toRepair() {
      this.$router.push({ path: '/Repair' })
    },
    showPassword(event) {
      if (this.pwdType === 'password') {
        this.pwdType = 'text'
        this.eyeType = 'el-input__icon el-icon-loading'
      } else {
        this.pwdType = 'password'
        this.eyeType = 'el-input__icon el-icon-view'
      }
    },
    // 生成随机数
    randomNum(min, max) {
      return Math.floor(Math.random() * (max - min) + min)
    },
    // 切换验证码
    refreshCode() {
      // this.identifyCode = ''
      // this.makeCode(this.identifyCodes, 4)
      let src = this.imgSrc
      this.imgSrc = ''
      this.$nextTick(() => {
        this.imgSrc = src + '?'
        console.log(this.imgSrc)
      })
    }
    // 生成四位随机验证码
    // makeCode(o, l) {
    //   for (let i = 0; i < l; i++) {
    //     this.identifyCode += this.identifyCodes[
    //       this.randomNum(0, this.identifyCodes.length)
    //     ]
    //   }
    //   console.log(this.identifyCode)
    // }
  }
}



// WEBPACK FOOTER //
// ./src/views/Login.vue